export const calendarAuthorized = {
	csw: true,
	agencyuser: true,
	child: true,
	contributor: { role: ['resource-parent'] },
	casauser: true,
};
